import React from 'react';

import {Box, Stack, Typography, useMediaQuery, useTheme} from '@mui/material';

import icons from 'assets/icons';
import {PremiumLock} from 'components';

const styles = {
    root: {
        cursor: 'pointer',
        margin: '2px',
        position: 'relative',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'grey.darkest',
        width: {
            mobile: '50px',
            desktop: '70px',
        },
        height: {
            mobile: '50px',
            desktop: '70px',
        },
    },
    colorCircle: {
        borderRadius: '50%',
        width: '100%',
        height: '100%',
    },
    selected: {
        backgroundColor: 'grey.dark',
    }
};

const FlyoutButton = ({icon, title, color, onClick, selected, iconSize, edge = false, isPremium = false}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));

    const SvgIcon = icons[icon];

    let size = isMobile ? '25px' : '35px';

    let sizeSelected = isMobile ? '32px' : '45px';

    if (iconSize) {
        size = iconSize;
    }

    return <Stack
        sx={[styles.root, selected && styles.selected, edge && styles[edge]]}
        onClick={isPremium ? () => console.log('LINK TO PREMIUM PAGE') : onClick}
    >
        {isPremium && <PremiumLock small />}

        {icon ? (
            <SvgIcon style={{
                fill: color ? color : theme.palette.white.main,
                stroke: color,
                display: 'block',
                width: selected ? sizeSelected : size,
                height: selected ? sizeSelected : size,
            }}/>
        ) : (
            <Box
                sx={[
                    styles.colorCircle,
                    {
                        backgroundColor: color ? color : theme.palette.white.main,
                        width: selected ? sizeSelected : size,
                        height: selected ? sizeSelected : size,
                        borderRadius: '50%',
                    }]}
            />)
        }
        {title && <Typography>{title}</Typography>}
    </Stack>;
};

export default FlyoutButton;
